import { Component, OnInit } from '@angular/core';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [],
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Informace o cookies',
      description: 'Informace o používání cookies na webu Logical Finance. Zjistěte, jaké typy cookies používáme a jak můžete spravovat jejich nastavení.',
      keywords: 'cookies, ochrana údajů, google analytics, soukromí',
      url: '/informace-o-cookies'
    });
  }
}

